<script setup>
import { onMounted, ref } from "vue";
import { Icon, Input, ProfilePicture, Textarea } from "@components";
import { getPrice, showDurationUnit } from "@utils";

import CenterLayout from "./CenterLayout.vue";

import { useService } from "@store/service.js";
const $service = useService();

import { useChatCustomizer } from "@store/chatCustomizer";
const $chatCustomizer = useChatCustomizer();

import { useSettings } from "@store/settings";
const $settings = useSettings();

onMounted(() => {
  $service.fetchData();
});

const questions = ref("Great! What service would you like to book?");

const selectedService = ref(null);
const default_banner =
  prebook_admin?.url?.assets + "images/chat-customizer-top-banner.jpeg";
</script>

<template>
  <CenterLayout>
    <div
      class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10"
      :style="{
        'background-color': $settings.customizer?.design?.brand_color,
      }"
    >
      <img
        v-if="$settings.settings.chat_widget.banner.image"
        :src="$settings.settings.chat_widget.banner.image"
        class="cursor-pointer"
        alt=""
      />
      <img
        v-else
        :src="default_banner"
        class="cursor-pointer"
        alt=""
        style="object-fit: cover; width: 100%; height: -webkit-fill-available"
      />
    </div>

    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div
      class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto"
      style="box-shadow: 0px 50px 76px -2px rgba(11, 17, 29, 0.1)"
    >
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Textarea
          v-model="$settings.settings.chat_widget.service.question"
        ></Textarea>
      </div>

      <div class="flex flex-col gap-2">
        <div
          v-for="service in $service.getServices"
          :key="service.service_id"
          @click="selectedService = service.service_id"
          class="flex gap-3 items-center rounded-xl p-[12px_16px_12px_12px] cursor-pointer border-[1.5px]"
          :class="[
            selectedService == service.service_id
              ? 'border-[#D0D5DD]'
              : 'border-transparent bg-[#F2F4F7]',
          ]"
        >
          <ProfilePicture
            :name="service.name"
            :img="service.meta?.thumbnail_image_url"
            :bgColor="service.meta?.color"
            :textClass="`!w-[60px] !h-[60px] !rounded-xl ${
              selectedService !== service.service_id
                ? 'border-4 border-[#FCFCFD]'
                : ''
            }`"
            :imgClass="`!w-[60px] !h-[60px] !rounded-xl ${
              selectedService !== service.service_id
                ? 'border-4 border-[#FCFCFD]'
                : ''
            }`"
          />
          <div class="flex flex-col gap-2 w-full">
            <div class="text-base font-semibold text-[#101828]">
              {{ service.name }}
            </div>
            <div
              class="text-sm text-[#475467]"
              v-if="service.meta.price_type != 'none'"
            >
              {{
                service.meta?.price_type == "free"
                  ? "Free"
                  : getPrice(service.meta?.price)
              }}
            </div>
          </div>
          <div class="text-[#475467] text-sm text-nowrap font-semibold">
            {{
              showDurationUnit(
                service.meta.duration,
                service.meta.duration_unit
              ) || "0 min"
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 text-center font-semibold text-lg">...</div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Service</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>
            Your service list will be updated from your system automatically.
          </li>
          <li>You can change service items from dashboard.</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>

<style></style>
